var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNazad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 456,
    viewBox: "0 0 74 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.700783 0.800781V455.201V407.909C-0.700783 386.887 7.25752 366.643 21.5742 351.249L51.4242 319.152C65.7409 303.758 73.6992 283.515 73.6992 262.492V224.801V193.509C73.6992 172.487 65.7409 152.243 51.4242 136.849L21.5742 104.752C7.25754 89.3581 -0.700783 69.1148 -0.700783 48.0921V0.800781Z",
    fill: "url(#paint0_linear_268_15005)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_268_15005",
    x1: -0.700783,
    y1: 224.801,
    x2: 73.6992,
    y2: 224.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNazad);
export default __webpack_public_path__ + "static/media/nazad.ecf4ae5079aa235ea01d3b29f3246904.svg";
export { ForwardRef as ReactComponent };